import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import moment from 'moment';

// Services
import { SharedService } from '../../../layouts/shared-service';
import { CustomeraircraftsService } from '../../../services/customeraircrafts.service';
import { AnatylticsReports, analyticsReports } from '../analytics-activity-reports/analytics-activity-reports.component';
import { AnaliticsReportType } from '../analytics-report-popup/analytics-report-popup.component';
import { ActivatedRoute } from '@angular/router';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';
import { StorageService } from 'src/app/services/security/storage.service';
import { Subscription } from 'rxjs';

export interface AnalyticsWidget {
    id: string;
    label: string;
    colClass: string;
}

export const DEFAULT_ANALYTICS_WIDGET_ORDER: AnalyticsWidget[] = [
    { id: 'fuel-vendor-sources', label: 'Fuel Vendor Sources', colClass: 'col-md-6' },
    { id: 'market-share', label: 'Market Share', colClass: 'col-md-6' },
    { id: 'quotes-orders-won', label: 'Your Quotes & Orders Won', colClass: 'col-md-6' },
    { id: 'monthly-fuel-orders', label: 'Your Monthly Fuel Orders', colClass: 'col-md-6' },
    { id: 'top-customers', label: 'Your Top Customers', colClass: 'col-md-6' },
    { id: 'volumes-nearby', label: 'Fuel Transaction Count at Nearby Airports', colClass: 'col-md-6' },
];

@Component({
    selector: 'app-analytics-home',
    styleUrls: ['./analytics-home.component.scss'],
    templateUrl: './analytics-home.component.html',
})
export class AnalyticsHomeComponent implements OnInit {
    public pageTitle = 'Analytics';
    public filterStartDate: Date;
    public filterEndDate: Date;
    public pastThirtyDaysStartDate: Date;
    public tailNumbers: any[] = [];
    public authenticatedIcao: string = '';
    public selectedRerport: AnatylticsReports;

    widgets: AnalyticsWidget[] = [];

    constructor(
        private customerAircraftsService: CustomeraircraftsService,
        private sharedService: SharedService,
        private cdr: ChangeDetectorRef,
        private route: ActivatedRoute,
        private ls: StorageService
    ) {
        this.filterStartDate = new Date(
            moment().add(-12, 'M').format('MM/DD/YYYY')
        );
        this.filterEndDate = new Date(moment().format('MM/DD/YYYY'));
        this.pastThirtyDaysStartDate = new Date(
            moment().add(-30, 'days').format('MM/DD/YYYY')
        );

        this.authenticatedIcao = this.sharedService.currentUser.icao;
    }

    routeSubscription: Subscription;

    ngOnInit() {
        this.loadWidgetOrder();
        this.getAircrafts();

        var isSingleSourceFbo: boolean = JSON.parse(
            this.sharedService
                .getCurrentUserPropertyValue(
                    localStorageAccessConstant.isSingleSourceFbo
                )
        );

        this.routeSubscription = this.route.queryParams.subscribe(params => {
            const reportType = params['report'] as AnaliticsReportType;
            if(reportType == AnaliticsReportType.LostToCompetition && !isSingleSourceFbo){
                this.openReport(analyticsReports[AnaliticsReportType.LostToCompetition]);
            }
        });
    }
    ngOnDestroy() {
        this.routeSubscription?.unsubscribe();
    }
    getAircrafts() {
        this.customerAircraftsService
            .getAircraftsListByGroupAndFbo(
                this.sharedService.currentUser.groupId,
                this.sharedService.currentUser.fboId
            )
            .subscribe((tailNumbers: any[]) => {
                this.tailNumbers = tailNumbers;
            });
    }
    openReport(reportType: AnatylticsReports) {
        this.selectedRerport = null;
        this.cdr.detectChanges();
        this.selectedRerport = reportType;
        this.cdr.detectChanges();
    }

    loadWidgetOrder(): void {
        const savedOrder = this.sharedService.analyticsSettings.widgetOrder;
        if (savedOrder && savedOrder.length) {
            this.widgets = savedOrder
                .map(id => DEFAULT_ANALYTICS_WIDGET_ORDER.find(w => w.id === id))
                .filter(w => !!w);
            // Append any new widgets not in saved order
            DEFAULT_ANALYTICS_WIDGET_ORDER.forEach(w => {
                if (!this.widgets.find(existing => existing.id === w.id)) {
                    this.widgets.push(w);
                }
            });
        } else {
            this.widgets = [...DEFAULT_ANALYTICS_WIDGET_ORDER];
        }
    }

    onWidgetDrop(event: CdkDragDrop<AnalyticsWidget[]>): void {
        moveItemInArray(this.widgets, event.previousIndex, event.currentIndex);
        this.sharedService.analyticsSettings.widgetOrder = this.widgets.map(w => w.id);
        this.ls.set(
            localStorageAccessConstant.analyticsSettings,
            JSON.stringify(this.sharedService.analyticsSettings)
        );
    }
}
